<template>
  <el-col :span="span">
    <el-form-item :label="label" :required="required">
      <!--普通输框-->
      <el-input :disabled="disabled" :placeholder="'请填写'+ label" v-if="!types&&!input" v-model="myValue" :rows="rows" :type="type" :readonly="readonly"></el-input>
      <!--类型输入框-->
      <el-select :disabled="disabled" :placeholder="'请选择'+ label" v-if="types&&input!=='node'" v-model="myValue" value-key="id" :readonly="readonly" filterable :multiple="multiple">
        <el-option value=""></el-option>
        <el-option v-for="opt in types" :label="opt.name" :key="opt.id" :value="opt.id" :readonly="readonly"></el-option>
      </el-select>
      <!--上传输入框-->
      <my-upload :disabled="disabled" v-if="input==='upload'" :placeholder="'请上传'+ label" :accept="accept" v-model="myValue" :readonly="readonly"></my-upload>
      <!--上传多个文件框-->
      <my-uploads :disabled="disabled" v-if="input==='uploads'" :myid="myid" :placeholder="'请上传'+ label" v-model="myValue" :readonly="readonly"></my-uploads>
      <!--富文本输入框-->
      <my-edit-input :disabled="disabled" v-if="input==='edit'" :placeholder="'请填写'+ label" v-model="myValue" :readonly="readonly"></my-edit-input>
      <!--时间日期输入框-->
      <el-date-picker :disabled="disabled" v-if="input==='datetime'" :placeholder="'请选择'+ label" v-model="myValue" value-format="yyyy-MM-dd HH:mm:ss" type="datetime" style="width: 100%"></el-date-picker>
      <!--日期输入框-->
      <el-date-picker :disabled="disabled" v-if="input==='date'" :placeholder="'请选择'+ label" v-model="myValue" value-format="yyyy-MM-dd" type="date" style="width: 100%"></el-date-picker>
      <!--下拉输入框-->
      <el-cascader :disabled="disabled" v-if="input==='node'" :placeholder="'请选择'+ label" v-model="myValue" :options="types" :props="$cascader" :show-all-levels="false" style="width:100%"></el-cascader>
      <!--启用禁用输入框-->
      <el-select :disabled="disabled" v-if="input==='enable'" :placeholder="'请选择'+ label" v-model="myValue" filterable>
        <el-option value=""></el-option>
        <el-option :value=1 label="启用"></el-option>
        <el-option :value=0 label="禁用"></el-option>
      </el-select>
    </el-form-item>
  </el-col>
</template>
<script>
export default {
  props: {
    span: { default: 6 },
    type: {},
    readonly: {},
    disabled: { default: false },
    label: {},
    input: {},
    value: {},
    required: {},
    types: [],
    upload: { default: false },
    editor: { default: false },
    date: { default: false },
    datetime: { default: false },
    filetype: {},
    rows: {},
    accept: {},
    multiple: { default: false },
    node: { default: false },
    enable: { default: false },
    myid: {}
  },
  data() {
    return {
      myValue: this.value,
    };
  },

  beforeMount() {
    if (this.input === "node") {
      this.$multiple(this.multiple);
    }
  },

  watch: {
    //监听内容变化
    value(newValue) {
      this.myValue = newValue
    },
    myValue(newValue) {
      this.$emit('input', newValue)
    }
  },

}
</script>

<style>
</style>